import Link from "next/link";

export interface SuggestionItemProps {
  _id: string;
  name: string;
  alias: string | undefined;
}

function SuggestionItem({ _id, name, alias }: SuggestionItemProps) {
  return (
    <Link href={`/abertura-de-vagas/${_id}`}>
      <li className="mr-10 mt-2 w-fit pl-0 font-roboto text-sm font-normal md:text-base">
        <span className="border border-x-0 border-t-0 border-solid">
          {alias ?? name}
        </span>
      </li>
    </Link>
  );
}

export default function Suggestions({
  suggestions,
}: {
  suggestions?: SuggestionItemProps[];
}) {
  return (
    <ul className="list-inside p-0 text-aubergine-perl-600">
      {suggestions?.map((suggestion) => (
        <SuggestionItem
          key={suggestion._id}
          _id={suggestion._id}
          name={suggestion.name}
          alias={suggestion.alias}
        />
      ))}
    </ul>
  );
}
